export type VisibleNavItemsUser = { isGlobalAdmin: boolean; profile: string } | null | undefined;

export function resolveVisibleNavItems<T extends { profiles: string[] }>(items: readonly T[], user: VisibleNavItemsUser): T[] {
    if (!user) {
        return [];
    }
    if (user.isGlobalAdmin) {
        return [...items];
    }
    return items.filter((item) => item.profiles.includes(user.profile));
}
